import { fetchGetters } from '@/store/extensions/fetch';
import { createGetters } from '@/store/extensions/create';
import { updateGetters } from '@/store/extensions/update';
import { deleteGetters } from '@/store/extensions/delete';

export default {
  ...fetchGetters,
  ...createGetters,
  ...updateGetters,
  ...deleteGetters,

  context: state => state.context,
  formModalOpened: state => state.formModalOpened,
  formModalContext: state => state.formModalContext,

  currentCompany: (state, getters, rootState, rootGetters) => {
    const currentUser = rootGetters['entities/users/currentUser'];

    return currentUser ? getters.query().first(currentUser.company_id) : null;
  },
  isAppSubscribed: (state, getters, rootState, rootGetters) => appId => (
    rootGetters['entities/appMemberships/query']()
      .where('app_id', appId)
      .where('company_id', getters.currentCompany.id)
      .where('active', true)
      .first()
  ),
};



// WEBPACK FOOTER //
// ./src/store/modules/company/getters.js